'use client';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Link, List, ListItem } from '@mui/material';
import { getSPSCategoryURL } from '@/global/utils/spsURLs';
import { SPSPartCategoryAllCategoriesResponse } from '@/shared/types/controllers/sps/SPSPartCategoryControllerTypes';
import { isNonEmptyArray } from '@/shared/types/util/TypeGuards';
const navLinkSx = {
  fontWeight: 'fontWeightMedium',
  color: 'text.secondary',
  py: 1.5,
  display: 'block',
  '&:hover, &:focus': {
    color: 'text.secondary'
  },
  '.Mui-expanded &.MuiTypography-bodyLarge': {
    fontWeight: 600
  }
};
type CategoryLinkProps = {
  category: SPSPartCategoryAllCategoriesResponse['partCategories'][number];
  isDefaultExpanded: boolean;
};
export const CategoryLink = ({
  category,
  isDefaultExpanded
}: CategoryLinkProps) => {
  if (isNonEmptyArray(category.children)) {
    return <Accordion disableGutters key={category.id} sx={{
      p: 0,
      mb: 1,
      borderWidth: 0,
      '&:before': {
        display: 'none'
      }
    }} defaultExpanded={isDefaultExpanded}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`${category.id}-content`} id={`${category.id}-header`} sx={{
        p: 0,
        borderWidth: 0,
        minHeight: 0,
        justifyContent: 'start',
        '.MuiAccordionSummary-content': {
          my: 0,
          flexGrow: 0,
          pr: 1
        }
      }}>
          <Link variant="bodyMedium" sx={navLinkSx} title={`Search ${category.name} Parts`} onClick={e => e.stopPropagation()} href={getSPSCategoryURL(category)}>
            {category.name}
          </Link>
        </AccordionSummary>
        <AccordionDetails sx={{
        p: 0,
        pb: 1,
        pl: 1.5,
        borderWidth: 0
      }}>
          <List sx={{
          p: 0
        }}>
            {category.children.map(childCategory => <ListItem key={childCategory.id} sx={{
            p: 0
          }}>
                <Link variant="bodySmall" sx={{
              ...navLinkSx,
              py: 1,
              fontWeight: 400
            }} title={`Search ${childCategory.name} Parts`} href={getSPSCategoryURL(childCategory)}>
                  {childCategory.name}
                </Link>
              </ListItem>)}
          </List>
        </AccordionDetails>
      </Accordion>;
  }
  return <Link variant="bodyMedium" sx={navLinkSx} title={`Search ${category.name} Parts`} href={getSPSCategoryURL(category)} data-sentry-element="Link" data-sentry-component="CategoryLink" data-sentry-source-file="CategoryLink.tsx">
      {category.name}
    </Link>;
};